import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { DocumentsCardContainer } from '@/features/jobs/details/components/DocumentsCard/DocumentsCardContainer'
import { ConsultationCallCardContainer } from '@/features/jobs/details/components/ConsultationCallCard/ConsultationCallCardContainer'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'
import { MobileJobBody } from '@/features/jobs/details/components/MobileJob'
import { MobileJobProgressionSummaryContainer } from './MobileJobProgressionSummaryContainer'
import { MobileJobChatContainer } from './MobileJobChatContainer'
import { MobileDetailsTabContainer } from './MobileDetailsTabContainer'
import { InfoGatheringDialogsContainer } from '@/features/jobs/details/components/InfoGatheringDialogsContainer'

export interface MobileJobBodyContainerProps {
  vm: JobDetailsViewModel
}

export const MobileJobBodyContainer = observer(function MobileJobBodyContainer({
  vm,
}: MobileJobBodyContainerProps) {
  useActivation(vm)
  useDocumentTitle(`${vm.job.workspace.name} | ${vm.job.displayName}`)

  return (
    <>
      <MobileJobBody
        hasConsultation={!!vm.job.consultation}
        header={<MobileJobProgressionSummaryContainer vm={vm} />}
        chat={<MobileJobChatContainer vm={vm} />}
        documents={<DocumentsCardContainer vm={vm} />}
        details={<MobileDetailsTabContainer vm={vm} />}
        consultation={<ConsultationCallCardContainer vm={vm} />}
      />
      <InfoGatheringDialogsContainer vm={vm.capturedInformationVm} />
    </>
  )
})
